import { default as indexZahkCkAn1GMeta } from "/nuxtapp/pages/auth/login/index.vue?macro=true";
import { default as verifyLsCozsawzzMeta } from "/nuxtapp/pages/auth/verify.vue?macro=true";
import { default as indexULf0hq7hSkMeta } from "/nuxtapp/pages/funds/index.vue?macro=true";
import { default as index7Y3ALvkP9SMeta } from "/nuxtapp/pages/index.vue?macro=true";
import { default as welcomekKwhulgJTHMeta } from "/nuxtapp/pages/welcome.vue?macro=true";
export default [
  {
    name: "auth-login",
    path: "/auth/login",
    component: () => import("/nuxtapp/pages/auth/login/index.vue").then(m => m.default || m)
  },
  {
    name: "auth-verify",
    path: "/auth/verify",
    component: () => import("/nuxtapp/pages/auth/verify.vue").then(m => m.default || m)
  },
  {
    name: "funds",
    path: "/funds",
    component: () => import("/nuxtapp/pages/funds/index.vue").then(m => m.default || m)
  },
  {
    name: "index",
    path: "/",
    component: () => import("/nuxtapp/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "welcome",
    path: "/welcome",
    component: () => import("/nuxtapp/pages/welcome.vue").then(m => m.default || m)
  }
]